/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getproductDetails, addshoppingCart } from '@/api';
import { mapState } from 'vuex';
import wx from 'wx';
export default {
  name: 'productDetails',
  data: function data() {
    return {
      ProductDetailsData: {},
      id: this.$route.params.id,
      show: false,
      num: 1
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['enterprise', 'user'])),
  methods: {
    onSubmit: function onSubmit() {
      this.show = true;
    },
    getProductDetailsData: function getProductDetailsData() {
      var _this = this;
      return getproductDetails({
        fk_t_shop_goods_id: this.id
      }).then(function (res) {
        if (res.success) {
          _this.ProductDetailsData = res.data;
        }
      });
    },
    letGo: function letGo(path) {
      this.$router.push(path);
    },
    addShopCart: function addShopCart() {
      var _this2 = this;
      var data = {
        fk_t_shop_product_id: this.ProductDetailsData.fk_t_shop_goods_id,
        add_munber: this.num
      };
      addshoppingCart(data).then(function (res) {
        if (res.success) {
          _this2.$vux.toast.text(i18n.tc("636"));
          _this2.show = false;
        } else {
          _this2.$vux.toast.text(i18n.tc("637"));
        }
      });
    }
  },
  // mounted(){
  //     this.getProductDetailsData()
  // },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.getProductDetailsData();
            case 2:
              if (_this3.enterprise.is_wx_auth) {
                console.log(123);
                wx.ready(function () {
                  console.log('wx ready');
                  wx.hideMenuItems({
                    menuList: ['menuItem:copyUrl'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                  });
                  var menu = ['updateAppMessageShareData', 'updateAppMessageShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'];
                  var data = {
                    title: _this3.ProductDetailsData.goods_name,
                    // 分享标题
                    desc: i18n.tc("638"),
                    // 分享描述
                    link: "".concat(location.origin, "/").concat(_this3.user.epCode, "/index2/goodsdetail/").concat(_this3.id),
                    // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: _this3.ProductDetailsData.goods_image,
                    // 分享图标
                    success: function success(e) {
                      console.log('AutoConsole: success -> e', e);
                      // 设置成功
                    },
                    fail: function fail(e) {
                      console.log('AutoConsole: error -> e', e);
                    }
                  };
                  menu.forEach(function (v) {
                    return wx[v](data);
                  });
                  //需在用户可能点击分享按钮前就先调用
                  // wx.updateAppMessageShareData()
                });
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
};